
import { Vue, Component, Prop } from 'vue-property-decorator';
import lazyInject from '@/di';
import { AgencyOperationService } from '@/services/agency_operation.service';


@Component
export default class AgencyTypeModal extends Vue {
  visible = false;

  radioValue = 1;

  @lazyInject(AgencyOperationService)
  agencyOperationService!: AgencyOperationService;

  @Prop({
    type: String,
    default: '1',
  })
  comType!: string;

  formData: any = {};

  handleChange(value: any) {
    console.log(value);
    this.radioValue = value.target.value;
    this.formData.cate = this.radioValue;
  }

  init(val: any) {
    this.visible = true;
    if (this.comType === 'agencyBatch') {
      const _d = {
        ids: val,
        cate: this.radioValue,
      };
      this.formData = _d;
    } else {
      if (val.category) {
        this.radioValue = val.category;
      }
      const _d = {
        agent_id: val.uid,
        cate: this.radioValue,
      };

      this.formData = _d;
    }
    console.log(this.formData);
  }

  cancel() {
    this.visible = false;
  }

  async confirm() {
    const res = await this.agencyOperationService.postAgentCategory(this.formData);
    if (res) {
      this.$emit('refresh', this.radioValue);
      this.visible = false;
      this.$message.success('设置成功');
    }
  }
}
